<template>
	<v-container v-if="listaCreches.length > 0 && temDisponibilidade"  fluid class="fill-height pa-0 ma-0">
		<v-row align="start" class="ma-0 pa-0 fill-height p-relative">
			<!-- Grid das datas -->
			<colunas-data :lista-datas="listaDatas" />
			<!-- Grid das creches -->
			<v-container fluid class="fill-height d-flex flex-row space">
				<!-- Linha dos dias -->
				<v-row class="ma-0 pb-0 px-0  d-flex flex-nowrap">
					<v-container class="ma-0 pa-0" style="max-width: 160px; min-width: 160px;" />
					<v-col class="ma-0 pa-0 d-flex justify-start align-start"
					       v-for="(item, i) in listaDatas" :key="i" style="min-width: 162px; max-width: 400px">
						<v-row class="ma-0 pa-4 fill-height d-flex flex-column justify-center align-center">
              <span class="text-datas-extenso text-capitalize">
                {{ item.data | formataData(false, 'dddd') }}
              </span>
							<span class="pl-2 text-datas-number">
                {{ item.data | formataData(false, 'DD/MM') }}
              </span>
						</v-row>
					</v-col>
					<v-container style="width: 20px"></v-container>
				</v-row>

				<!--  Linha das creches -->
				<v-row v-for="(crechario, index) in listaCreches" :key="index"
				       class="ma-0 pa-0 creche-card__row p-relative z-1">
					<!-- Cabeçalho da creche -->
					<v-row class="ma-0 pa-0 d-flex flex-nowrap">
						<v-container class="ma-0 pa-0" style="max-width: 160px">
							<div class="ma-0 pa-4 d-flex flex-column ">
								<span class="titulo__text">Crechário</span>
								<span class="crechario__text">
		                {{ crechario.dadosCreche.nmProdutor || crechario.dadosCreche.nmEstabelecimento }}
	              </span>
								<span class="data__text pt-0">{{ crechario.dadosCreche.nmLocalidade }}</span>
								<span class="data__label__text pt-2">
			              UEP
		              <span class="data__text">
		              {{ crechario.dadosCreche.nrUnidadeExploracao }}
		              </span>
	              </span>

								<span class="data__label__text pt-2">
			              Lote de controle
	              </span>
								<span class="big__data__text" style="font-size: 14px;">
			              {{ crechario.dadosCreche.nrLoteControle }}
	              </span>

								<span class="data__label__text pt-4">
			              Idade
	              </span>
								<span class="data__text">
			              {{ crechario.dadosCreche.nrDiasLote }} dias
	              </span>

								<span class="data__label__text pt-2">
			              Total de animais
	              </span>
								<span class="data__text">
			              {{ crechario.dadosCreche.qtSaldoAnimais }}
	              </span>
				  				<span class="data__label__text pt-2">
			              Observação
	              </span>
								<span class="data__text break__line_text">
			              {{ crechario.dsObservacao }}
	              </span>

								<alocar-lotes-dialog :crechario="crechario"
								                     :listaLotesDestino="listaLotesDestino[crechario.dadosCreche.cdEstabelecimento]"
								                     :listaDatas="listaDatas">
									<template v-slot:activator="{ on }">
										<v-btn elevation="0" color="#2BC1B6" height="40" class="mt-4" dark v-on="on"
										       :loading="loadingLoteDestinoAlojamento">
											Inserir Lotes
										</v-btn>
									</template>
								</alocar-lotes-dialog>
							</div>
						</v-container>

						<!-- Colunas dos dias -->
						<v-col class="ma-0 pa-0 d-flex justify-start align-start"
						       v-for="(data, idx) in listaDatas" style="min-width: 162px; max-width: 400px"
						       :key="idx"
						>
							<v-container
									align="center"
									justify="space-between"
									class="ma-0 d-flex flex-row p-relative fill-height">
								<alojamento-card-lotes
										:crechario.sync="listaCreches[index]"
										:dataAlojamento="data"
										:listaPeriodoEntregaAlojamento="listaPeriodoEntregaAlojamento"
										:canEdit="canEdit"
								/>
							</v-container>
						</v-col>
						<v-container style="width: 20px"></v-container>
					</v-row>
					<!-- Linha do saldo -->
					<div class="saldo__card__spacer d-flex full-width">
						<div class="ma-2  full-width" style="height: 46px"></div>
					</div>
					<div class="saldo__card__wrapper p-absolute d-flex full-width">
						<div class="ma-2 saldo__card full-width" style="height: 46px"></div>
					</div>
					<saldo-alocado-crechario :crechario="crechario" :listaDatas="listaDatas" />
				</v-row>
			</v-container>
		</v-row>
	</v-container>

	<!--  Estado sem creches -->
	<alert-sem-dados-para-etapa :loading="loading" titulo="Sem creches selecionadas"
	                            sub-titulo="Favor selecionar creches na aba Creches"
	                            v-else-if="listaCreches.length === 0" />
	<!--  Estado sem Disponibilidade -->
	<alert-sem-dados-para-etapa :loading="loading" titulo="Disponibilidade não preenchida"
	                            sub-titulo="Favor preencher a disponibilidade na aba Disponibilidade"
	                            v-else />
</template>

<script>
import * as moment from "moment";
import {MODELS} from "../../resources";
import ColunasData from "./ColunasData";
import AlocarLotesDialog from "./AlocarLotesDialog";
import AlojamentoCardLotes from "./AlojamentoCardLotes";
import {mapActions, mapMutations, mapState} from "vuex";
import SaldoAlocadoCrechario from "./SaldoAlocadoCrechario";
import AlertSemDadosParaEtapa from "../DetalhePlanejamentoAlojamento/AlertSemDadosParaEtapa";

export default {
	name: "Alojamento",
	components: {
		AlertSemDadosParaEtapa,
		SaldoAlocadoCrechario,
		AlocarLotesDialog,
		ColunasData,
		AlojamentoCardLotes,
	},
	data: () => ({
		listaCreches: [],
		loading: true,
		canEdit: true,
		listaPeriodoEntregaAlojamento: [],
	}),
	mounted() {
		if(this.listaLotesDestino.length > 0 &&
				this.listaLotesDestino[0].cdPlanejamentoAlojamento !== parseInt(this.$route.params.id))
			this.mtChangeListaLoteDestinoAlojamento([])

		this.btnConfirmarAlojamento()
		this.loadListaCreches()
		this.loadListaPeriodoEntregaAlojamento()
		this.ActLoadListaLoteAlocado(this.$route.params.id)
	},
	computed: {
		...mapState("planejamentoAlojamento", {
			listaLotesDestino: "listaLotesDestinoAlojamento",
			loadingLoteDestinoAlojamento: "loadingLoteDestinoAlojamento",
		}),
		listaDatas() {
			if (!this.planejamentoAlojamento || this.planejamentoAlojamento.cdPlanejamentoAlojamento === 0) return []

			const dataInicio = this.planejamentoAlojamento.dtInicioAlojamento
			const dataFim = this.planejamentoAlojamento.dtFimAlojamento
			const diffDias = moment(dataFim).diff(dataInicio, 'days') + 1

			let arrayDias = [];

			for (let i = 0; i < diffDias; i++) {
				arrayDias.push({dia: i + 1, data: moment(dataInicio).add(i, 'days').format('YYYY-MM-DD')})
			}

			return arrayDias
		},
		temDisponibilidade() {
			let blDisponivel = false
			return this.listaCreches.some((creche) => {
				for (let i = 1; i < 8; i++) {
					blDisponivel = parseInt(creche[`qtFemeasDia${i}`] || 0) > 0 || parseInt(creche[`qtMachosDia${i}`] || 0) > 0
					if (blDisponivel) break
				}
				return blDisponivel
			})
		}
	},
	methods: {
		...mapActions("planejamentoAlojamento", ["ActLoadListaLoteDestinoAlojamento", "ActLoadListaLoteAlocado"]),
		...mapMutations("planejamnentoAlojamento", ["mtChangeListaLoteDestinoAlojamento"]),
		loadListaCreches() {
			this.$axios.get(`/planejamento-alojamento-disponibilidade/?cdPlanejamentoAlojamento=${this.$route.params.id}`)
					.then(res => {
						if (!res.data) return
						if (!res.data[0].data) {
							this.loading = false
							return
						}

						let requestDadosCreche = []
						let creches = res.data[0].data.sort((ant, pos) => {
							if (ant.nrDiasLote > pos.nrDiasLote) return 1
							if (ant.nrDiasLote < pos.nrDiasLote) return -1
							return 0
						})

						creches.forEach((creche, index) => {
							if (creche && creche['cdLoteProducaoCreche'] > 0) {
								requestDadosCreche.push(this.$axios.get(`lote-producao/${creche[`cdLoteProducaoCreche`]}/planejamento-alojamento/`)
										.then(res => {
											if (!res.data) return
											if (!res.data[0].data) return

											const lote = res.data[0].data

											const crecheComLote = new MODELS.DADOS_CRECHE.constructor(
													lote['nmProdutor'],
													lote['nmMunicipio'],
													lote['nrUnidadeExploracao'],
													lote['nrLoteControle'],
													lote['qtDiasLote'],
													lote['qtSaldoAnimais'],
													lote['cdEstabelecimento'],
											)

											_.extend(creches[index], {index: index, dadosCreche: crecheComLote})
										})
										.catch(error => {
											this.$store.commit("setSnack", {type: "error", msg: error})
											_.extend(creches[index], {index: index, dadosCreche: MODELS.DADOS_CRECHE})
										}))
							} else {
								requestDadosCreche.push(
										this.$axios.get(`/creche-sem-lote/${creche['cdCrecheSemLote']}/lote-producao/`)
												.then(res => {
													if (!res.data) return
													if (!res.data[0].data) return

													const lote = res.data[0].data

													const crecheSemLote = new MODELS.DADOS_CRECHE.constructor(
															lote['nmProdutor'],
															lote['nmMunicipio'],
															lote['nrUnidadeExploracao'] || '--',
															'--',
															'--',
															'--',
															lote['cdEstabelecimento'],
															'--',
															lote['nmEstabelecimento'],
													)
													_.extend(creches[index], {index: index, dadosCreche: crecheSemLote})
												})
												.catch(error => {
													this.$store.commit("setSnack", {type: "error", msg: error})
													_.extend(creches[index], {index: index, dadosCreche: MODELS.DADOS_CRECHE})
												}))
							}
						})

						Promise.all(requestDadosCreche).finally(() => {
							this.listaCreches = creches
							const cdsEstabelecimentoCreches = _.uniq(creches.map(creche => creche.dadosCreche.cdEstabelecimento)).join(',')

							this.ActLoadListaLoteDestinoAlojamento({
									cdPlanejamentoAlojamento: this.$route.params.id,
									listaCdEstabelecimentoCreche: cdsEstabelecimentoCreches
							})

							this.loading = false
						})
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error})
						this.loading = false
					})
		},
		loadListaPeriodoEntregaAlojamento(){
			this.$axios.get('/periodo-entrega-alojamento/')
					.then(res => {
						if (!res.data) return
						if (!res.data[0].data) return

						this.listaPeriodoEntregaAlojamento = res.data[0].data
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error})
					})
		},
		confirmarAlojamento() {
			this.$axios.put('/planejamento-alojamento-disponibilidade/preencher-disponibilidade-creches/?cdPlanejamentoAlojamento=' + this.$route.params.id,
					this.listaCreches)
					.then(res => {
						if (!res.data) return
						if (!res.data[0].data) return

						this.$store.commit("setSnack", {type: "success", msg: 'Alojamento salvo!'})

						if (this.planejamentoAlojamento.cdStatusPlanejamentoAlojamento === 4) {
							this.$emit('proximaEtapa', 6)
							this.btnConfirmarAlojamento()
						} else {
							this.btnConfirmarAlojamento()
						}
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error})
					})
					.finally(() => {
						this.loading = false
					})
		},
		esconderBtn() {
			this.$emit('update:btnConfirmar', {
				show: false,
				texto: 'Confirmar',
				acao: false,
				acaoType: '',
			})
		},
		btnConfirmarAlojamento() {
			this.$emit('update:btnConfirmar', {
				show: true,
				texto: 'Confirmar',
				acao: false,
				acaoType: 'confirmarAlojamento',
			})
		},
	},
	filters: {
		formataData(date, ISO, formatoSaida) {
			let tipoData = ISO ? moment.ISO_8601 : 'YYYY-MM-DD'
			const parsedDate = moment(date, tipoData)
			if (!parsedDate.isValid()) return ""
			return parsedDate.format(formatoSaida)
		},
	},
	watch: {
		'btnConfirmar.acao'(acao) {
			if (acao && this.btnConfirmar.acaoType === 'confirmarAlojamento')
				this.confirmarAlojamento()
		}
	},
	props: {
		planejamentoAlojamento: {
			type: Object,
			required: true,
		},
		btnConfirmar: {
			show: false,
			texto: 'Confirmar',
			acao: false,
			acaoType: '',
		},
	}
}
</script>

<style scoped lang="scss">
.first-col {
  background-color: transparent !important;
  border-top-left-radius: 6px;
  z-index: 1;
}

.saldo__card__wrapper {
  bottom: 0;
  z-index: 1;
}

.saldo__card {
  border: 1px solid #f3f3f3;
  border-radius: 8px;
  background: #E5E8E7;
}

.saldo__text {
  font: normal normal bold 17px/20px Roboto;
  letter-spacing: 0px;
  color: #10303D;
}

.creche-card__row {
  margin-bottom: 40px !important;
  background-color: #f2f5f3 !important;
  border: 1px solid #e5e8e7;
  border-radius: 8px;
  opacity: 1;
}

.total-float {
  width: 100%;
  left: 0;
  position: sticky;
  bottom: 20px;
  z-index: 99999999;
}

.total-float__row {
  background: white;
  border: 1px solid #f3f3f3;
  border-radius: 5px;
}

.card-col__text {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #7B9596;
}

.data__text {
  font: normal normal bold 12px/16px Roboto;
  letter-spacing: 0;
  color: #37565C;
  line-break: anywhere;
}

.break__line_text {
  line-break: anywhere;
}

.titulo__text {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #7B9596;
}

.crechario__text {
  font: normal normal bold 24px/32px Roboto;
  letter-spacing: 0;
  color: #FF5429;
}

.total-demand__text {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #37565C;
}

.total-demand__value {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #37565C;
}

.data__label__text {
  color: #12303C99;
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
}

.big__data__text {
  font: normal normal bold 16px/18px Roboto;
  letter-spacing: 0;
  color: #37565C;
}

.height-auto {
  flex-basis: 100% !important;
  max-height: 100px !important;
}

</style>
